





























































































// @ts-ignore
import v8n from 'v8n';
import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';
import { Customer, Vehicle, VehicleType, ApiError } from '@/api';
import { snackModule, bookingModule } from '@/store';
import ConfirmDialog from '@/components/admin/ConfirmDialog.vue';
import RelAutocomplete from '@/components/RelAutocomplete.vue';

@Component({
  components: {
    ConfirmDialog,
    RelAutocomplete,
  },
})
export default class extends Vue {
  @Prop({ required: true }) readonly customerId: number;
  @Prop({ required: false }) readonly selectedVehicle: Vehicle;

  loading: boolean = false;
  valid: boolean = false;
  complete: boolean = false;
  error: string = '';

  customer: Customer | null = null;

  vehicle: Vehicle | null = null;

  makeSelect: string = '';
  colourSelect: string = '';

  closeConfirmDialog: boolean = false;

  requiredString = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'This field is required',
  ];

  requiredObject = [
    (v: VehicleType) => {
      if (!v) {
        return 'This field is required';
      }

      return (
        v8n()
          .string()
          .not.empty()
          .test(v.id) || 'This field is required'
      );
    },
  ];

  get vehicleId() {
    return this.selectedVehicle.id;
  }

  get modalTitle() {
    return this.selectedVehicle ? 'Edit Vehicle' : 'Add Vehicle';
  }

  get makes() {
    const defaultMakes = bookingModule.makes;
    defaultMakes.push('Other');
    return defaultMakes;
  }
  get colours() {
    const defaultColours = bookingModule.colours;
    defaultColours.push('Other');
    return defaultColours;
  }

  vehicleTypeScopeFactory() {
    return VehicleType.includes([]).order({ name: 'asc' });
  }

  confirmClose() {
    if (this.vehicle && this.vehicle.isDirty()) {
      this.closeConfirmDialog = true;
    } else {
      this.close();
    }
  }

  close() {
    this.$emit('close-vehicle');
  }

  async save() {
    if (!this.vehicle || !this.customer) {
      return;
    }

    this.vehicle.owner = this.customer;

    if (this.vehicle.rego) {
      this.vehicle.rego = this.vehicle.rego.toUpperCase().replace(/\s/g, '');
    }

    if (this.makeSelect && this.makeSelect !== 'Other') {
      this.vehicle.make = this.makeSelect;
    }

    if (this.colourSelect && this.colourSelect !== 'Other') {
      this.vehicle.colour = this.colourSelect;
    }

    try {
      await this.vehicle.save({ with: ['vehicleType.id', 'owner.id'] });

      this.$emit('save-vehicle');
    } catch (err) {
      err.response.errors.forEach((e: ApiError) =>
        snackModule.showSnackbar(e.detail),
      );
    }
  }

  async mounted() {
    try {
      this.customer = (await Customer.find(this.customerId)).data;
    } catch (err) {
      snackModule.showSnackbar('Customer not found');
    }

    if (this.selectedVehicle && this.selectedVehicle.id) {
      try {
        const scope = await Vehicle.find(this.selectedVehicle.id);
        this.vehicle = scope.data;

        if (this.makes.includes(this.vehicle.make)) {
          this.makeSelect = this.vehicle.make;
        } else {
          this.makeSelect = 'Other';
        }

        if (this.colours.includes(this.vehicle.colour)) {
          this.colourSelect = this.vehicle.colour;
        } else {
          this.colourSelect = 'Other';
        }
      } catch (err) {
        // most likely this means not found
        snackModule.showSnackbar('Vehicle not found');
      }
    } else {
      this.vehicle = new Vehicle();
    }
  }
}
